import React from 'react';
import './Footer.css';
import LocationIcon from './icons/LocationIcon';
import CalendarIcon from './icons/CalendarIcon';
import GlobeIcon from './icons/GlobeIcon';
import PhoneIcon from './icons/PhoneIcon';
import EmailIcon from './icons/EmailIcon';
import { useTranslation } from '../utils/i18n';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <footer>
        <div id="footer-UI">
          <div id="div30">
            <div id="div31" className="row-footer ">
              <div id="div32" className="col-xl-4 col-lg-4 col-md-4">
                <div id="div33" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div id="div49" style={{ display: 'flex', alignItems: 'stretch' }}>
                    <span className="color-footer" id="text60">
                      <span style={{ textAlign: "start" }} className="text-border" id="text61">
                        {t('footer.contactUs')}
                      </span>
                    </span>
                  </div>
                  <div className="mt-3" id="div24" style={{ display: 'flex', alignItems: 'stretch' }}>
                    <span style={{ textAlign: "start" }} className="color-footer" id="text26">
                      <span id="text27">
                        {t('footer.contactDescription')}
                      </span>
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'stretch' }} id="div26">
                    <div id="div27">
                      <LocationIcon />
                    </div>
                    <span style={{ marginLeft: '10px', textAlign: "start" }} className="color-footer" id="text28">
                      <span style={{ textAlign: "start" }} id="text29">
                        {t('footer.address')}
                      </span>
                    </span>
                  </div>
                  <div id="div51" style={{ display: 'flex', alignItems: 'center' }}>
                    <CalendarIcon />
                    <span className="color-footer" id="text62" style={{ marginLeft: '10px', marginTop: "3px" }}>
                      <span id="text65">{t('footer.workingHours')}</span>
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }} id="div8">
                    <div style={{ marginTop: '2px', flexShrink: 0 }}>
                      <GlobeIcon />
                    </div>
                    <span className="color-footer" style={{ marginLeft: '10px', lineHeight: '1.4', marginTop: "3px" }} id="text6">
                      <span style={{ textAlign: "start" }} id="text7">{t('footer.budgetOffice')}</span>
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start' }} id="div9">
                    <div style={{ marginTop: '2px', flexShrink: 0 }}>
                      <GlobeIcon />
                    </div>
                    <span className="color-footer" style={{ marginLeft: '10px', textAlign: "start", lineHeight: '1.4', marginTop: "3px" }} id="text8">
                      <span style={{ textAlign: "start" }} id="text9">{t('footer.innovationSystem')}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4" id="div10">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }} id="div11">
                  <div style={{ display: 'flex', alignItems: 'stretch' }} id="div12">
                    <span className="color-footer" id="text10">
                      <span style={{ textAlign: "start" }} className="text-border" id="text11">
                        {t('footer.ourServices')}
                      </span>
                    </span>
                  </div>
                  <div id="div14" className="mt-3" style={{ display: 'flex', alignItems: 'stretch' }}>
                    <span className="color-footer" id="text12">
                      <span style={{ textAlign: "start" }} id="text13">{t('footer.aboutUs')}</span>
                    </span>
                  </div>
                  <div id="div15" style={{ display: 'flex', alignItems: 'stretch' }}>
                    <span className="color-footer" id="text14">
                      <span style={{ textAlign: "start" }} id="text15">{t('footer.survey')}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div id="div17" className="col-xl-4 col-lg-4 col-md-4">
                <div id="div18" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'stretch' }} id="div19">
                    <span style={{ textAlign: "start" }} id="text18" className="color-footer">
                      <span id="text19" className="text-border">
                        {t('footer.others')}
                      </span>
                    </span>
                  </div>
                  <div className="mt-3" style={{ display: 'flex', alignItems: 'stretch' }} id="div21">
                    <span style={{ textAlign: "start" }} id="text20" className="color-footer">
                      <span style={{ textAlign: "start" }} id="text21">{t('footer.documentService')}</span>
                    </span>
                  </div>
                  <div id="div22" style={{ display: 'flex', alignItems: 'baseline' }}>
                    <PhoneIcon />
                    <span style={{ marginLeft: '10px', textAlign: "start" }} id="text22" className="color-footer">
                      <span style={{ textAlign: "start" }} id="text23">{t('footer.phoneNumbers')}</span>
                    </span>
                  </div>
                  <div id="div23" style={{ display: 'flex', alignItems: 'center' }}>
                    <EmailIcon />
                    <span style={{ marginLeft: '10px' }} id="text24" className="color-footer">
                      <span style={{ textAlign: "start" }} id="text25">{t('footer.email')}</span>
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }} id="div21">
                    <span className="color-footer" id="text24">
                      <span style={{ textAlign: "start" }} id="text25">{t('footer.termsOfService')}</span>
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }} id="div21">
                    <span className="color-footer" id="text24">
                      <span style={{ textAlign: "start" }} id="text25">{t('footer.cookiePolicy')}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
